import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { PATTERNS } from "../../util/patterns";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { post } from "../../util/httpClient";
import { Notification } from "../common/Notification";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNo } from "../../util/phoneNumberValidationUtil";

const RequestBreachCodesDialog: React.FunctionComponent<{ closeDialog(): void }> = (props) => {
    const [isLoading, setisLoading] = useState(false);
    const [errorMsg, seterrorMsg] = useState("");
    const [hasError, setHasError] = useState(false);
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const userPhone =
        accountInfo?._personalAccountInformation != null ? accountInfo._personalAccountInformation.primaryPhone : accountInfo != null ? accountInfo.phone : null;
    const businessInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._businessInformation
                : null
            : null
    );
    const businessName: string = businessInformation && businessInformation.businessName ? businessInformation.businessName : "";

    const { register, errors, handleSubmit, setError, control } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const userInfo = useSelector((state: ApplicationState) => {
        if (state.loggedInUser !== null) {
            return {
                firstName: state.loggedInUser?.activeAccount?.firstName,
                lastName: state.loggedInUser?.activeAccount?.lastName,
                email: state.loggedInUser?.userInfo?.EmailAddress,
                phoneNumber: userPhone?.replace("1-", ""),
            };
        }
        return { firstName: "", lastName: "", email: "", phoneNumber: "" };
    });

    const handleBreachCodeQuantityChange = (evt: any) => {
        if (evt.currentTarget && evt.currentTarget.value) {
            const filterValue = evt.currentTarget.value.replace(/[^0-9]/g, "");
            evt.currentTarget.value = filterValue;
        }
    };

    const saveRequest = (data: any) => {
        setHasError(false);

        const quantity = data["breachCodeQuantity"];
        if (quantity && Number(quantity) && Number(quantity) > 100000) {
            setError("breachCodeQuantity", {
                type: "pattern",
            });
            return;
        }

        const requestBody = {
            firstName: data["firstName"],
            lastName: data["lastName"],
            email: data["email"],
            phone: data["Phone"],
            businessName: data["businessName"],
            breachCodeQuantity: data["breachCodeQuantity"],
        };
        setisLoading(true);
        return post("api/userServices/CreateSalesForceCaseVictimServices", requestBody)
            .then((data) => {
                setisLoading(false);
                if (data.hasError === false) {
                    Notification({
                        type: "success",
                        title: "Request Received",
                        message:
                            "We have received your breach codes request. Support will be in touch very soon to assist you in processing and deploying your breach codes.",
                        duration: 10,
                    });
                    closeDialog();
                } else if (data.hasError && data.errorMessage.length > 0) {
                    seterrorMsg(data.errors.join(", "));
                    setHasError(true);
                } else {
                    seterrorMsg("We're sorry. We were unable to add your item. Please try again.");
                    setHasError(true);
                }
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: "Error",
                    message: "We're sorry. We were unable to add your item. Please try again.",
                    duration: 0,
                });
            });
    };

    useEffect(() => {
        const elements = document.getElementsByClassName("PhoneInputCountry");

        if (elements && elements.length > 0) {
            try {
                for (const el of elements) {
                    const childs = el.children;
                    if (childs[0].nodeName === "SELECT") {
                        const selectEl = childs[0] as HTMLSelectElement;
                        selectEl.disabled = true;
                    }
                }
            } catch {}
        }
    }, []);

    const getCountryInfo = () => {
        let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";

        if (currentCountry.includes("US") || currentCountry.includes("CA") || currentCountry === "") {
            return false;
        } else {
            return true;
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="cube" />
                </div>
                <h1>Request Breach Codes</h1>
                <p>If your company has experienced a data breach and you would like to request protection for affected individuals, complete the form below.</p>
            </div>

            <form onSubmit={handleSubmit(saveRequest)} id="request-breach-codes-form-container">
                <div className={isLoading ? "dialog-body loading" : "dialog-body"}>
                    <div className="row row-split-2">
                        <div className="col-xs-12 col-no-gutter col-sm">
                            <div className="form-row">
                                <div className="form-label">
                                    <label htmlFor="first-name-label">
                                        First Name{" "}
                                        <span className="required" title="Mandatory">
                                            *
                                        </span>
                                    </label>
                                </div>
                                <div className="form-input">
                                    <input
                                        type="text"
                                        name="firstName"
                                        className="inputbox"
                                        id="first-name-label"
                                        defaultValue={userInfo?.firstName}
                                        placeholder="Enter First Name"
                                        ref={register({ pattern: /^[a-zA-Z\s\-']+$/, required: true })}
                                    />
                                    {!!errors["firstName"] && errors["firstName"].type === "required" && <span className="form-error">First Name is required</span>}
                                    {!!errors["firstName"] && errors["firstName"].type === "pattern" && (
                                        <span className="form-error">Please enter valid first name.</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-no-gutter col-sm">
                            <div className="form-row">
                                <div className="form-label">
                                    <label htmlFor="last-name-label">
                                        Last Name{" "}
                                        <span className="required" title="Mandatory">
                                            *
                                        </span>
                                    </label>
                                </div>
                                <div className="form-input">
                                    <input
                                        type="text"
                                        name="lastName"
                                        className="inputbox"
                                        id="last-name-label"
                                        defaultValue={userInfo?.lastName}
                                        placeholder="Enter Last Name"
                                        ref={register({ pattern: /^[a-zA-Z\s\-']+$/, required: true })}
                                    />
                                    {!!errors["lastName"] && errors["lastName"].type === "required" && <span className="form-error">Last Name is required</span>}
                                    {!!errors["lastName"] && errors["lastName"].type === "pattern" && (
                                        <span className="form-error">Please enter valid last name.</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row row-split-2">
                        <div className="col-xs-12 col-no-gutter col-sm">
                            <div className="form-row">
                                <div className="form-label">
                                    <label htmlFor="email-label">
                                        Email{" "}
                                        <span className="required" title="Mandatory">
                                            *
                                        </span>
                                    </label>
                                </div>
                                <div className="form-input">
                                    <input
                                        type="text"
                                        name="email"
                                        className="inputbox"
                                        id="email-label"
                                        defaultValue={userInfo?.email}
                                        placeholder="Enter Email Address"
                                        ref={register({
                                            required: true,
                                            pattern: PATTERNS.EMAIL.pattern,
                                        })}
                                    />
                                    {!!errors["email"] && errors["email"].type === "required" && <span className="form-error">Email is required</span>}
                                    {!!errors["email"] && errors["email"].type === "pattern" && <span className="form-error">Please enter valid email.</span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-no-gutter col-sm">
                            <div className="form-row">
                                <div className="form-label">
                                    <label htmlFor="phone-number-label">
                                        Phone Number{" "}
                                        <span className="required" title="Mandatory">
                                            *
                                        </span>
                                    </label>
                                </div>

                                <Controller
                                    name={`Phone`}
                                    control={control}
                                    defaultValue={userInfo ? String(userInfo.phoneNumber) : ""}
                                    className="inputbox support-input"
                                    rules={{
                                        required: true,
                                        validate: (value) =>
                                            value ? isValidPhoneNo(accountInfo && accountInfo.country ? accountInfo.country : "US", value) : false,
                                    }}
                                    render={({ onChange, value }) => (
                                        <PhoneInput
                                            value={value}
                                            onChange={onChange}
                                            international={false}
                                            addInternationalOption={false}
                                            defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                            countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                            id="phone-number-label-support"
                                            placeholder="Enter Phone Number"
                                            maxLength={15}
                                            minLength={10}
                                        />
                                    )}
                                />
                                {!!errors["Phone"] && errors["Phone"].type === "required" && <span className="form-error">Phone is required</span>}
                                {!!errors["Phone"] && errors["Phone"].type === "validate" && (
                                    <span className="form-error">Invalid format. Please enter a valid phone number.</span>
                                )}
                                {!!errors["Phone"] &&
                                    errors["Phone"].type === "minLength" &&
                                    (getCountryInfo() ? (
                                        <span className="form-error">Phone Number must be a minimum of 7 digits in length.</span>
                                    ) : (
                                        <span className="form-error">
                                            Invalid format. Please enter a 10-digit phone number, {/* not including the country code, */} in the following format:
                                            (888) 123-4567.
                                        </span>
                                    ))}
                                {!!errors["Phone"] &&
                                    errors["Phone"].type === "maxLength" &&
                                    (getCountryInfo() ? (
                                        <span className="form-error">Phone Number must be a maximum of 15 digits in length.</span>
                                    ) : (
                                        <span className="form-error">
                                            Invalid format. Please enter a 10-digit phone number, {/* not including the country code, */} in the following format:
                                            (888) 123-4567.
                                        </span>
                                    ))}
                            </div>
                        </div>
                    </div>

                    <div className="row row-split-2">
                        <div className="col-xs-12 col-no-gutter col-sm">
                            <div className="form-row">
                                <div className="form-label">
                                    <label htmlFor="business-name-label">
                                        Business Name{" "}
                                        <span className="required" title="Mandatory">
                                            *
                                        </span>
                                    </label>
                                </div>
                                <div className="form-input">
                                    <input
                                        type="text"
                                        name="businessName"
                                        className="inputbox"
                                        id="business-name-label"
                                        defaultValue={businessName}
                                        placeholder="Enter Business Name"
                                        ref={register({ pattern: /^[a-zA-Z0-9-',.&()\s]+$/, required: true })}
                                    />
                                    {!!errors["businessName"] && errors["businessName"].type === "required" && (
                                        <span className="form-error">Business Name is required</span>
                                    )}
                                    {!!errors["businessName"] && errors["businessName"].type === "pattern" && (
                                        <span className="form-error">
                                            Invalid Format. Business Name can only include letters, numbers, spaces, and the special characters: ' . , -()&
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-no-gutter col-sm">
                            <div className="form-row">
                                <div className="form-label">
                                    <label htmlFor="breach-code-quantity-label">
                                        Breach Code Quantity{" "}
                                        <span className="required" title="Mandatory">
                                            *
                                        </span>
                                    </label>
                                </div>
                                <div className="form-input">
                                    <input
                                        type="text"
                                        name="breachCodeQuantity"
                                        className="inputbox"
                                        id="breach-code-quantity-label"
                                        defaultValue={""}
                                        placeholder="Enter Code Quantity"
                                        ref={register({ pattern: /^[1-9][0-9]{0,5}$/, required: true, min: 1, max: 100000 })}
                                        maxLength={6}
                                        onInput={(e) => handleBreachCodeQuantityChange(e)}
                                    />
                                    {!!errors["breachCodeQuantity"] && errors["breachCodeQuantity"].type === "required" && (
                                        <span className="form-error">Breach Code Quantity is required</span>
                                    )}
                                    {!!errors["breachCodeQuantity"] && errors["breachCodeQuantity"].type === "pattern" && (
                                        <span className="form-error">You can request for minimum 1 & maximum 100,000 breach codes at once.</span>
                                    )}
                                    {!!errors["breachCodeQuantity"] && errors["breachCodeQuantity"].type === "min" && (
                                        <span className="form-error">You can request for minimum 1 & maximum 100,000 breach codes at once.</span>
                                    )}
                                    {!!errors["breachCodeQuantity"] && errors["breachCodeQuantity"].type === "max" && (
                                        <span className="form-error">You can request for minimum 1 & maximum 100,000 breach codes at once.</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {hasError && (
                        <div className="col-xs-12 col-no-gutter col-sm">
                            <div className="form-row">
                                <p className="form-error">{errorMsg}</p>
                            </div>
                        </div>
                    )}
                </div>

                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                <span className="btn-text">Close</span>
                            </button>
                        </div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="submit" className="btn-default btn-primary">
                                <span className="btn-text">Submit</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
};

export default RequestBreachCodesDialog;
